import React from "react";
import { Page } from "../../../activities/AppPage";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppButton } from "../../Generic/AppButton";
import { AppCard, AppCardContent } from "../../Generic/AppCard";
import SafeArea from "../../Generic/SafeArea";
import useFlag from "../../MainV2Screen/hooks/useFlag";

type Props = {
  onRequestNavigate: (page: Page) => void;
};

export default function CareMomentsIntroButton(props: Props) {
  const careMomentsFlag = useFlag({ name: "OpenedCareMomentsIntro" });

  return (
    <AppCard>
      <AppCardContent>
        <SafeArea bottom={true}>
          <AppButton
            size="large"
            block
            onClick={() => {
              careMomentsFlag.markAsFlagged();
              props.onRequestNavigate({ type: "CareMoments" });
            }}
          >
            {translate(STRINGS.GET_STARTED)}
          </AppButton>
        </SafeArea>
      </AppCardContent>
    </AppCard>
  );
}
